import { render, staticRenderFns } from "./SimplePage.vue?vue&type=template&id=0471d664&scoped=true&"
import script from "./SimplePage.vue?vue&type=script&lang=js&"
export * from "./SimplePage.vue?vue&type=script&lang=js&"
import style0 from "./SimplePage.vue?vue&type=style&index=0&id=0471d664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0471d664",
  null
  
)

export default component.exports